"use client";

import { parseAsJson, useQueryState } from "nuqs";
import { z } from "zod";
import { SEARCH_PARAM_KEYS } from "@/constants/search-param-keys";
import type { Destinations, Filters } from "@/types/images-categories.types";

const schema = z.object({
  filter: z.string<Filters>(),
  destination: z.string<Destinations>(),
});

export function useMainGalleryQueries() {
  const [mainGallery, setMainGallery] = useQueryState(
    SEARCH_PARAM_KEYS.MAIN_GALLERY,
    parseAsJson(schema).withDefault({
      filter: "all",
      destination: "all",
    })
  );

  return { mainGallery, setMainGallery };
}
